import * as React from "react";
import { useMemo } from "react";
import usePermissions from "hooks/usePermissions";
import sortNavigationItems from "components/navigation/util/sortNavigationItems";
import usePluginEntities from "hooks/usePluginEntities";
import mergeAndSortNavigationItems from "components/navigation/util/mergeAndSortNavigationItems";
import AppConfig from "util/AppConfig";
import NavTabs from "components/common/NavTabs";
const usePageNavigationItems = (page, items) => {
  const allPageNavigationItems = usePluginEntities("pageNavigation");
  return useMemo(() => {
    var _a, _b;
    if (items) {
      return sortNavigationItems(items);
    }
    return (_b = (_a = mergeAndSortNavigationItems(allPageNavigationItems).find((item) => item.description === page)) == null ? void 0 : _a.children) != null ? _b : [];
  }, [items, allPageNavigationItems, page]);
};
const PageNavigation = ({ page = void 0, items: itemsProp = void 0 }) => {
  const { isPermitted } = usePermissions();
  const items = usePageNavigationItems(page, itemsProp);
  const availableItems = items.filter(
    (item) => (item.requiredFeatureFlag ? AppConfig.isFeatureEnabled(item.requiredFeatureFlag) : true) && (typeof item.useCondition === "function" ? item.useCondition() : true) && isPermitted(item.permissions) && !!item.path
  );
  if (availableItems.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(NavTabs, { items: availableItems });
};
export default PageNavigation;
